module.exports = __webpack_public_path__ + "static/img/case_detail_02_2.cba1beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_02_2.png
// module id = B23H
// module chunks = 34